@let connecte = isAuth$ | async;

<footer class="bg-footer text-gray-300 font-raleway">
  <div class="container px-6 pt-12 pb-6 lg:px-20">
    <div class="grid grid-cols-1 gap-10 md:grid-cols-3">

      <!-- Le groupe -->
      <div class="flex flex-col items-center gap-4 text-center md:items-start md:text-left">
        <a href="/" aria-label="La Bourrée de Paris, accueil">
          <img src="assets/images/logo.png" alt="" class="h-24 w-auto object-contain">
        </a>
        <p class="max-w-xs text-sm leading-relaxed">
          Groupe folklorique auvergnat de Paris, il fait vivre les danses, musiques et chants du Massif Central depuis 1925.
        </p>
        <ul class="flex items-center gap-3" aria-label="Réseaux sociaux">
          <li>
            <a href="https://www.facebook.com/LaBourreedeParis" target="_blank" rel="noopener noreferrer"
              aria-label="La Bourrée de Paris sur Facebook (nouvel onglet)"
              class="flex h-10 w-10 items-center justify-center rounded-full border border-gray-400 text-gray-200 transition hover:border-white hover:bg-white hover:text-blue-dark">
              <svg class="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                <path fill-rule="evenodd" d="M13.135 6H15V3h-1.865a4.147 4.147 0 0 0-4.142 4.142V9H7v3h2v9.938h3V12h2.021l.592-3H12V6.591A.6.6 0 0 1 12.592 6h.543Z" clip-rule="evenodd"/>
              </svg>
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/la_bourree_de_paris/" target="_blank" rel="noopener noreferrer"
              aria-label="La Bourrée de Paris sur Instagram (nouvel onglet)"
              class="flex h-10 w-10 items-center justify-center rounded-full border border-gray-400 text-gray-200 transition hover:border-white hover:bg-white hover:text-blue-dark">
              <svg class="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="currentColor" fill-rule="evenodd" d="M3 8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8Zm5-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H8Zm7.597 2.214a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z" clip-rule="evenodd"/>
              </svg>
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/@la_bourree_de_paris" target="_blank" rel="noopener noreferrer"
              aria-label="La Bourrée de Paris sur YouTube (nouvel onglet)"
              class="flex h-10 w-10 items-center justify-center rounded-full border border-gray-400 text-gray-200 transition hover:border-white hover:bg-white hover:text-blue-dark">
              <svg class="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                <path fill-rule="evenodd" d="M21.7 8.037a4.26 4.26 0 0 0-.789-1.964 2.84 2.84 0 0 0-1.984-.839c-2.767-.2-6.926-.2-6.926-.2s-4.157 0-6.928.2a2.836 2.836 0 0 0-1.983.839 4.225 4.225 0 0 0-.79 1.965 30.146 30.146 0 0 0-.2 3.206v1.5a30.12 30.12 0 0 0 .2 3.206c.094.712.364 1.39.784 1.972.604.536 1.38.837 2.187.848 1.583.151 6.731.2 6.731.2s4.161 0 6.928-.2a2.844 2.844 0 0 0 1.985-.84 4.27 4.27 0 0 0 .787-1.965 30.12 30.12 0 0 0 .2-3.206v-1.516a30.672 30.672 0 0 0-.202-3.206Zm-11.692 6.554v-5.62l5.4 2.819-5.4 2.801Z" clip-rule="evenodd"/>
              </svg>
            </a>
          </li>
        </ul>
      </div>

      <!-- Navigation -->
      <nav aria-labelledby="footer-nav" class="text-center md:text-left">
        <h2 id="footer-nav" class="mb-4 font-alice text-xl text-white">Le site</h2>
        <ul class="space-y-2 text-sm">
          <li><a href="/" class="hover:text-white hover:underline">Accueil</a></li>
          <li><a href="/a-propos" class="hover:text-white hover:underline">À propos</a></li>
          <li><a href="/evenements" class="hover:text-white hover:underline">Événements</a></li>
          <li><a href="/actualites" class="hover:text-white hover:underline">Actualités</a></li>
        </ul>
        <div class="mt-5 text-sm font-medium">
          @if (connecte) {
            <button type="button" (click)="logout()"
              class="cursor-pointer rounded-lg border border-gray-400 p-2 text-gray-200 hover:underline">
              Se déconnecter
            </button>
          } @else {
            <a href="/login" class="inline-block rounded-lg border border-gray-400 p-2 text-gray-200 hover:underline">
              Se connecter à l'intranet
            </a>
          }
        </div>
      </nav>

      <!-- Contact -->
      <div class="text-center md:text-left">
        <h2 class="mb-4 font-alice text-xl text-white">Nous contacter</h2>
        <ul class="space-y-3 text-sm">
          <li>
            <a [href]="'mailto:' + association.email" class="hover:text-white hover:underline">{{ association.email }}</a>
          </li>
          <li>
            <a [href]="'tel:' + association.telephoneHref" class="hover:text-white hover:underline">{{ association.telephone }}</a>
          </li>
          <li>
            <span class="block font-medium text-white">Salle de répétition</span>
            {{ association.salleRepetition }}
          </li>
        </ul>
      </div>
    </div>

    <!-- Bandeau du bas -->
    <div class="mt-10 flex flex-col items-center gap-3 border-t border-white/15 pt-6 text-xs md:flex-row md:justify-between">
      <p>© 1925-{{ annee }} <a href="/" class="font-bold text-white hover:underline">{{ association.nom }}</a></p>

      <nav aria-label="Informations légales">
        <ul class="flex flex-wrap justify-center gap-x-5 gap-y-2">
          <li><a href="/mentions-legales" class="hover:text-white hover:underline">Mentions légales</a></li>
          <li><a href="/confidentialite" class="hover:text-white hover:underline">Confidentialité</a></li>
          <li><a href="/cookies" class="hover:text-white hover:underline">Cookies</a></li>
          @if (connecte) {
            <li><a href="/cgu" class="hover:text-white hover:underline">Conditions d'utilisation</a></li>
          }
          <li><button type="button" (click)="openCookiePreferences()" class="hover:text-white hover:underline">Gérer mes cookies</button></li>
        </ul>
      </nav>
    </div>
  </div>

  <!-- Signature Studio Rose (inchangée) -->
  <div class="text-sm text-gray-500 text-center">
    <a href="https://www.studio-rose.fr" target="_blank" rel="noopener noreferrer" aria-label="Studio Rose (nouvel onglet)">
      <div class="w-20 bg-neutral-200 rounded-t-xl mx-auto p-1">
        <img src="assets/svg/rose-studio.svg" alt="" class="w-1/2 object-contain mx-auto">
      </div>
    </a>
  </div>
</footer>
